import React, { Component } from "react";
import { Row, Card, Icon, Input, Button } from "antd";
import moment from "moment";
import axios from "axios";
import { Translate, Translator } from "react-translated";
import F from "../../Functions";
import AssociateUserTags from "../../components/associate-user-tags";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class SearchDuplicateCustomers extends Component {
  state = {
    loading: false,
    bfiles: [],
    agency_id: "",
    user: this.props.auth.user,
    search: "",
    selectedRowIndexes: [], // [1,3] ==>> indexes
    selectedRowBFileData: [], // []
    lastSearch: ""
  };

  componentDidMount() {
    const state = this.props.location.state;

    if (state !== undefined && state && state.lastSearch) {
      const srch = state.lastSearch;
      const isString = typeof srch === "string";
      this.setState({ search: isString ? srch : "" }, () => this.onSearch());
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    const lastSearch = queryParams.get('lastSearch');
    if (lastSearch) {
      this.setState(prevState => ({
        ...prevState,
        lastSearch: lastSearch,
        search: lastSearch
      }), () => {
        this.onSearch();
      })
    }
  }

  onSearch = () => {
    const { search } = this.state;

    const searchPurify = F.removeSpecialCharactersFromString(search);

    if (searchPurify.trim().length > 0) {
      this.setState({ loading: true, lastSearch: searchPurify });
      axios.get("/api/search_bfile_m/" + searchPurify).then((res) => {
        this.setState({
          loading: false,
          bfiles: res.data
        });
      });
    }
  };
  onSelectionChanged = (event) => {
    const { bfiles } = this.state;
    const api = event && event.api;
    if (!api) return;
    const selectedNodes = api.getSelectedNodes();
    const selectedRowIndexes = selectedNodes
      .map(n => (n && n.data && typeof n.data.idx === 'number') ? n.data.idx : undefined)
      .filter(idx => typeof idx === 'number');
    const selectedRowBFileData = selectedRowIndexes
      .filter((idx) => bfiles[idx])
      .map((idx) => bfiles[idx]);
    this.setState({ selectedRowIndexes, selectedRowBFileData });
  };

  mergeCustomer = () => {
    // Remove previous "selected duplicate customers" from local storage
    window.localStorage.removeItem("duplicateCustomers");

    // Add new "selected duplicate customers" in local storage key "duplicateCustomers"
    window.localStorage.duplicateCustomers = JSON.stringify(
      this.state.selectedRowBFileData
    );

    // navigate to "/search-customers-to-merge-with" route
    // setTimeout(() => {
    //   this.props.history.push("/search-customers-to-merge-with");
    // }, 100);

    // navigate to last screen "merge-customers" route for client request
    setTimeout(() => {
      this.props.history.push(`/merge-customers?lastSearch=${this.state.lastSearch}`);
    }, 100);
    // setTimeout(() => {
    //   this.props.history.push("/merge-customers", {
    //     lastSearch: this.state.lastSearch
    //   });
    // }, 100);
  };


  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }

  render() {
    const {
      loading,
      bfiles,
      selectedRowIndexes,
      selectedRowBFileData
    } = this.state;


    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      let bfile = bfiles[i];

      let bfile_name = bfile.first_name + " " + bfile.last_name;
      if (!bfile.last_bfile) {
        bfile_name = (
          <div>
            {bfile.first_name + " " + bfile.last_name}
          </div>
        );
      }

      data.push({
        idx: i,
        name: bfile_name,
        created_on: moment(new Date(bfile.date)).format("MM/DD/YYYY"),
        agency_name: bfile.agency_name,
        phone: F.phone_format(bfile.phone),
        email: bfile.email,
        // associate_users: bfile.Associated_bfiles.concat(
        //   bfile.Associated_bfiles
        // ),
        associate_users: bfile.Associated_bfiles
      });
    }

    const columnDefs = [
      {
        headerName: "",
        field: "checkbox",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 50,
        sortable: false,
        filter: false,
        suppressMenu: true,
      },
      {
        headerName: 'Name',
        field: 'name',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Name'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Created Date',
        field: 'created_on',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Created Date'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Agency Name',
        field: 'agency_name',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Agency Name'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Phone',
        field: 'phone',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Phone'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Email',
        field: 'email',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Email'] },
        sortable: true,
        cellRendererFramework: params => params.value,
      },
      {
        headerName: 'Associate Users',
        field: 'associate_users',
        headerComponent: CustomHeader,
        headerComponentParams: { headers: ['Associate Users'] },
        sortable: true,
        width: 300,
        cellRendererFramework: params => <AssociateUserTags associate_users={params.value} />,
      },
    ];

    F.log("selectedRowBFileData==>>", JSON.stringify(selectedRowBFileData));

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              {/* <Translate text={`Search Duplicate Customers`} /> */}
              <React.Fragment><Icon style={{ color: "#1890ff", marginRight: "5px" }} type="search" /> <Translate text={` Search Duplicate Customers`} /></React.Fragment>

            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <Row
              gutter={16}
              //   style={{ maxWidth: "100%" }}
              type="flex"
              justify="end"
            >
              <Translator>
                {({ translate }) => (
                  <Input
                    className="custom-rounded-input"
                    suffix={
                      this.state.search ? (
                        <Icon
                          type="close"
                          onClick={() => {
                            this.setState({ search: "" }, () => {
                              this.onSearch();
                            });
                          }}
                          style={{ right: '5px' }}
                          className="icon-style"
                        />
                      ) : (
                        <Icon
                          type="search"
                          style={{ right: '5px' }}
                          className="icon-style"
                        />
                      )
                    }
                    value={this.state.search}
                    placeholder={translate({ text: `Search` }) + ""}
                    onChange={(e) => this.setState({ search: e.target.value })}
                    onPressEnter={this.onSearch}
                    width={200}
                  />
                )}
              </Translator>
            </Row>
          }
        >
          {selectedRowIndexes.length > 1 ? (
            <div className="toolbarButtons">
              <Button type="default"
                className="borderRadius-28"
                onClick={this.mergeCustomer}>
                <Translate text={`Merge Customer`} />
              </Button>
            </div>
          ) : null}
          <CustomAgGridTable
            rowDatas={data}
            columnDefss={columnDefs}
            onSelectionChanged={this.onSelectionChanged}
            rowSelection="multiple"
            onGridReady={this.onGridReady}
            onColumnMoved={this.saveState}
            onSortChanged={this.saveState}
            onFilterChanged={this.saveState}
            gridApiOptions={{
              immutableData: true,
              getRowId: params => (params && params.data && typeof params.data.idx !== 'undefined') ? String(params.data.idx) : undefined,
            }}
          />
        </Card>
      </div>
    );
  }
}

export default SearchDuplicateCustomers;



// WEBPACK FOOTER //
// ./src/scenes/SearchDuplicateCustomers/index.js